// Карта: лёгкая обёртка. Leaflet (~150 КБ) загружается, только когда карту впервые показывают
// (скрытая карта — пустой блок того же размера). Реализация — MapLeaflet.tsx.
// Тёмная тема: тайлы затемняются фильтром (.map-dark в styles.css).
import { lazy, Suspense, useState, type Ref } from 'react';

export interface MapMarker {
  lat: number | null | undefined;
  lon: number | null | undefined;
  label?: string;
  /** класс подписи (по умолчанию map-label) */
  className?: string;
  /** подпись видна всегда (по умолчанию да) */
  permanent?: boolean;
  color?: string;
  onClick?: () => void;
  /** номер внутри метки (маршрут дня: 1, 2, 3…) — метка крупнее, с цифрой */
  num?: string;
}

/** Линия маршрута (по точкам по порядку) */
export interface MapLine {
  points: [number, number][];
  color: string;
  dashed?: boolean;
}

export interface MapViewHandle {
  /** приблизить к маркеру и показать подпись */
  focus(i: number): void;
}

export interface MapViewProps {
  id?: string;
  markers: MapMarker[];
  /** линии маршрута под метками */
  lines?: MapLine[];
  center?: { lat: number; lon: number } | null;
  zoom?: number;
  className?: string;
  hidden?: boolean;
  ref?: Ref<MapViewHandle>;
}

export const isDarkTheme = (): boolean => document.documentElement.dataset.theme === 'dark'
  || (!document.documentElement.dataset.theme && typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches);

const MapLeaflet = lazy(() => import('./MapLeaflet'));

export function MapView(props: MapViewProps) {
  const [need, setNeed] = useState(!props.hidden);
  if (!props.hidden && !need) setNeed(true);
  const cls = props.className ? `map ${props.className}` : 'map';
  if (!need) return <div id={props.id} className={cls} hidden />;
  return (
    <Suspense fallback={<div id={props.id} className={`${cls} map-loading`} hidden={props.hidden} aria-busy="true" />}>
      <MapLeaflet {...props} />
    </Suspense>
  );
}
